import { styled } from 'styled-components';
import { Box } from '@mui/material';

export const OptionsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-width: 180px;
`;

export const OptionRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export const AllOptionText = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-left: 4px;
`;
